type InfinitePostsData = {
  pages: Array<{ posts: any[] }>;
  pageParams: any[];
};

export function patchInfinitePosts(
  data: any,
  postId: number,
  patch: (p: any) => any
) {
  if (!data?.pages) return data;

  return {
    ...data,
    pages: data.pages.map((page: any) => ({
      ...page,
      posts: (page.posts ?? []).map((p: any) =>
        p.id === postId ? patch(p) : p
      ),
    })),
  };
}
